import { useContext, useEffect, useState } from 'react'
import { multiplayer as multiplayer } from './multiplayer';
import { Game } from './components/Game';
import { MultiplayerMenu } from './components/MultiplayerMenu';
import { Lobby } from './components/Lobby';
import { eventHandlers } from './lib/utils';
import { AuthContext } from './context/auth';
import { usePlayerManagement } from './features/player-management/hooks/usePlayerManagement';


function App() {
  const [roomId, setRoomId] = useState<string | null>(null);
  const [gaming, setGaming] = useState(false);
  const [joining, setJoining] = useState(false);
  const auth = useContext(AuthContext);

  async function host() {
    const roomId = await multiplayer.host()
    setRoomId(roomId)
  }

  usePlayerManagement(auth.playerProfile)

  async function join(id: string) {
    setJoining(true);
    await multiplayer.join(id);
    setRoomId(id)
    multiplayer.send('ping', { time: Date.now() })
    setJoining(false);
  }

  useEffect(() => eventHandlers(
    multiplayer.packets.on('ping', (data) => {
      console.log('Received ping:', data);
      multiplayer.send('pong', { time: Date.now() });
    }),
    multiplayer.packets.on('pong', (data) => {
      console.log('Received pong:', data);
    }),
    multiplayer.packets.on('startGame', () => {
      setGaming(true)
    })
  ), []);

  function startGame() {
    multiplayer.send('startGame', {}, 'both')
  }

  if (gaming) {
    return <Game roomId={roomId!} />
  }

  return (
    <div className="flex flex-col w-full min-h-screen relative">
      {/* Main content - Connection UI */}
      <main className="flex-grow flex items-center justify-center">
        {
          roomId === null ? (
            <MultiplayerMenu host={host} join={join} joining={joining} />
          ) : (
            <Lobby onStartGame={() => startGame()} roomId={roomId} />
          )
        }
      </main>
    </div>
  );
}

export default App
